import { AppEnvironment } from 'types/appEnvironment';
import { AppEvent } from 'types/appEvent';
import { PrimitiveCache } from 'utils/primitiveCache/primitiveCacheTypes';
import { createPrimitiveCacheConstructor } from 'utils/primitiveCache/primitiveCacheUtils';
import { createReducer } from 'utils/reducer/reducerUtils';

export const reduceToNextAppEnvironment = createReducer<
  PrimitiveCache<AppEnvironment>,
  AppEvent
>((prev, event) => {
  switch (event.name) {
    case 'AppEnvironmentProcess__ValueRecieved':
      return createPrimitiveCacheConstructor(prev).setValue(event.value).get();
    default:
      return prev;
  }
});
